
















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { LOAD_FLOW, LOAD_FLOWS, SAVE_FLOW, UPDATE_STATUS } from '@/store/bot-designer/actionTypes';
import { MutationPayload } from 'vuex';
import { ADD_PATH, UPDATE_PATH, REMOVE_PATH } from '@/store/bot-designer/paths/mutationTypes';
import { ADD_STATE, REMOVE_STATE, UPDATE_STATE } from '@/store/bot-designer/states/mutationTypes';
import Toast from '@/shared/services/toast';
import ConfirmationModal from '@/shared/components/ConfirmationModal.vue';
import EditableText from '@/shared/components/EditableText.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import BackArrow from 'vue-material-design-icons/ArrowLeft.vue';
import {
	MAKE_DIRTY,
	RESET_CHANGE_TRACKER,
	SET_FLOW_NAME,
	SET_IS_SAVE_FLOW_IN_PROGRESS,
	UPDATE_FLOW_ID
} from '@/store/bot-designer/mutationTypes';
import {
	SET_TRIGGER,
	UPDATE_SCHEDULE_CONDITION,
	UPDATE_TRIGGER_CONDITIONS,
	UPDATE_AUDIENCE_CONDITIONS,
	UPDATE_TARGET_CONTACT_TYPES
} from '@/store/bot-designer/triggers/mutationTypes';
import { ChangeType } from '@/features/bots/models/designer';
import { Route } from 'vue-router';
import { flowsApi } from '@/features/bots/services/flows';
import { ParentViewModel } from '@/features/bots/models/parentViewModel';
import HtmlFormatter from '@/shared/services/htmlFormatter';
import appInsights from '@/shared/services/appInsights';
import EditableComponent from '@/shared/components/EditableComponent.vue';
import { BOT_STUDIO_ENABLED } from '@/store/app/featureTypes';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import PauseIcon from 'vue-material-design-icons/Pause.vue';
import PlayIcon from 'vue-material-design-icons/Play.vue';
import SaveIcon from 'vue-material-design-icons/ContentSave.vue';
import AdvancedTooltip from '@/shared/components/AdvancedTooltip.vue';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';
import { LOAD_INTENTS } from '@/store/intents/actionTypes';

@Component({
	components: {
		EditableComponent,
		ConfirmationModal,
		LoadingSpinner,
		EditableText,
		DeleteIcon,
		BackArrow,
		BotPreviewModal,
		DropDownMenu,
		PauseIcon,
		SaveIcon,
		PlayIcon,
		AdvancedTooltip,
		UpgradeModal
	}
})
export default class Flow extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public flowName!: string;
	@Getter public hasMadeChanges!: boolean;
	@Getter public isSaveFlowInProgress!: boolean;

	@Prop() public flowId: string;
	@Getter public isFlowInvalid!: boolean;
	@Getter public isCurrentFlowTriggerable!: boolean;
	@Getter public currentFlowStatus: FlowStatus;
	@Getter public isTransitioningToAnInactiveFlow: boolean;
	@Getter public parentFlows!: ParentViewModel[];
	@Getter public parentAnswers!: ParentViewModel[];
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;

	@Action(LOAD_FLOW) public loadFlow: any;
	@Action(SAVE_FLOW) public saveFlow: any;
	@Action(LOAD_FLOWS) public loadFlows: any;
	@Action(LOAD_INTENTS) public loadIntents: any;
	@Action(UPDATE_STATUS) public updateFlowStatus: (status: FlowStatus) => Promise<void>;
	@Mutation(SET_FLOW_NAME) public setFlowName: any;
	@Mutation(MAKE_DIRTY) public makeDirty: any;
	@Mutation(RESET_CHANGE_TRACKER) public resetChangeTracker: any;
	@Mutation(SET_IS_SAVE_FLOW_IN_PROGRESS) public setIsSaveFlowInProgress: any;
	@Mutation(UPDATE_FLOW_ID) public updateFlowId: any;

	public flowLoaded: boolean = false;
	public showDeleteModal: boolean = false;
	public showLeaveModal: boolean = false;
	public showPauseFlowModal: boolean = false;
	public showMakeLiveModal: boolean = false;
	public showBotPreviewModal: boolean = false;
	public showUpgradeModal: boolean = false;

	public showNoTriggerModal: boolean = false;

	public $refs: {
		leaveModal: any
	};

	private unsubscribeMutations: any;

	@Watch('flowId', { immediate: true })
	public async onFlowIdChange() {
		await this.loadFlows(); // if there's no flows, (refresh has happened)
		await this.loadIntents(); // Required to display names
		this.flowLoaded = false;
		this.resetTracking();
		await this.fetchFlow();
		this.flowLoaded = true;
	}

	public beforeRouteUpdate(to: Route, from: Route, next: any) {
		// called when the route that renders this component has changed,
		// but this component is reused in the new route.
		// For example, for a route with dynamic params `/foo/:id`, when we
		// navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
		// will be reused, and this hook will be called when that happens.
		// has access to `this` component instance.
		this.showModal(to, from, next);
	}

	public beforeRouteLeave(to: Route, from: Route, next: any) {
		// called when the route that renders this component is about to be navigated away from
		// if we want to intentionally bypass this check, the 'confirmed' route param must be populated
		this.showModal(to, from, next);
	}

	public destroyed() {
		if (this.unsubscribeMutations) {
			this.unsubscribeMutations();
		}
	}

	public deleteFlow() {
		appInsights.trackEvent({ name: 'Delete flow clicked' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
		const flowToDeleteName = this.flowName;
		flowsApi.deleteFlow(this.currentWorkspace.id, this.flowId).then(() => {
			this.$router.push({ name: 'bots-flows', params: { confirmed: 'true' } });
			Toast.showSuccess(`Deleted flow ${flowToDeleteName}`);
		}).catch(() => {
			Toast.showError(`Failed to delete flow ${flowToDeleteName}`);
		});
	}

	public async pauseFlow() {
		try {
			this.setIsSaveFlowInProgress(true);
			await this.updateFlowStatus(FlowStatus.Paused);
			appInsights.trackEvent({ name: 'Flow paused' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
			Toast.showSuccess(`Paused ${this.flowName}`);
		} catch (error) {
			Toast.showError(`Failed to pause flow ${this.flowName}`);
		}
		this.setIsSaveFlowInProgress(false);
		this.showPauseFlowModal = false;
	}

	public async makeFlowLive() {
		try {
			this.setIsSaveFlowInProgress(true);
			await this.updateFlowStatus(FlowStatus.Live);
			appInsights.trackEvent({ name: 'Made flow live' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
			Toast.showSuccess(`Made flow ${this.flowName} live`);
		} catch (error) {
			Toast.showError(`Failed to make flow ${this.flowName} live`);
		}
		this.setIsSaveFlowInProgress(false);
		this.showMakeLiveModal = false;
	}

	public saveButtonClicked() {
		appInsights.trackEvent({ name: 'Save flow clicked' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
		if (!this.isCurrentFlowTriggerable) {
			this.showNoTriggerModal = true;
		} else {
			this.saveChanges();
		}
	}

	public pauseFlowClicked() {
		appInsights.trackEvent({ name: 'Pause flow clicked' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
		if (!this.canPauseFlow) {
			Toast.showError(this.pauseFlowErrorMessage());
			return;
		}
		this.showPauseFlowModal = true;
	}

	public previewButtonClicked() {
		appInsights.trackEvent({ name: 'Preview clicked' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
		this.showBotPreviewModal = true;
	}

	public makeLiveButtonClicked() {
		appInsights.trackEvent({ name: 'Make live clicked' }, { flowId: this.flowId, workspaceId: this.currentWorkspace.id });
		this.showMakeLiveModal = true;
	}

	public async saveChanges() {
		this.showNoTriggerModal = false;
		this.setIsSaveFlowInProgress(true);

		setTimeout(async () => {
			try {
				await this.saveFlow();
				this.resetTracking();
				Toast.showSuccess('Successfully saved Flow');
			} catch (err) {
				Toast.showError(err.message);
			} finally {
				this.setIsSaveFlowInProgress(false);
			}
		}, 200);
	}

	public getDeleteConfirmationMessage() {
		return `Are you sure you want to delete <b>${HtmlFormatter.escapeHtmlCharacters(this.flowName)}</b>?`;
	}

	public getLeaveConfirmationMessage() {
		return `All changes you've made to <b>${HtmlFormatter.escapeHtmlCharacters(this.flowName)}</b> will be discarded. <br/>Are you sure you want to leave the page?`;
	}

	public getPauseConfirmationMessage() {
		return `This will prevent the flow from being triggered. Are you sure you want to continue?`;
	}

	public getMakeLiveConfirmationMessage() {
		return `This will make the flow active to your audience on the applicable channels. Are you sure you want to continue?`;
	}

	public getNoTriggerSelectedConfirmationMessage() {
		return `This flow has no triggers defined. Are you sure you want to continue?`;
	}

	public deleteFlowClicked() {
		if (!this.canDeleteFlow) {
			Toast.showError('Cannot delete a flow that is transitioned to by another flow or FAQ');
		} else {
			this.showDeleteModal = true;
		}
	}

	public isBotStudioEnabled() {
		return this.isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED);
	}

	public get isSaveButtonEnabled() {
		return !this.isSaveFlowInProgress && this.hasMadeChanges;
	}

	public get isPreviewButtonEnabled() {
		return !this.isFlowInvalid && !this.hasMadeChanges && !this.isSaveFlowInProgress;
	}


	public isPauseOptionVisible() {
		return this.currentFlowStatus === FlowStatus.Live;
	}

	public isMakeLiveButtonVisible() {
		return this.currentFlowStatus === FlowStatus.Paused || this.currentFlowStatus === FlowStatus.Draft;
	}

	public get canPauseFlow() {
		return (this.currentFlowStatus === FlowStatus.Live) && !this.hasLiveParentFlows() && !this.hasLiveParentAnswers() && !this.hasMadeChanges;
	}

	public get canDeleteFlow() {
		return this.parentFlows.length === 0 && this.parentAnswers.length === 0;
	}

	public get canMakeLive() {
		return !this.isFlowInvalid && !this.hasMadeChanges && !this.isSaveFlowInProgress && !this.isTransitioningToAnInactiveFlow && this.isBotStudioEnabled();
	}

	public get previewFlowErrorMessage() {
		if (this.hasMadeChanges) {
			return 'Cannot preview a flow with unsaved changes';
		}
		return '';
	}

	public get saveFlowErrorMessage() {
		if (!this.hasMadeChanges) {
			return 'No changes to save';
		}
		return '';
	}

	public get makeLiveErrorMessage() {
		if (this.isTransitioningToAnInactiveFlow) {
			return 'Must not transition to flow or FAQ that is not live';
		}
		if (this.hasMadeChanges) {
			return 'Cannot make flow live with unsaved changes';
		}

		return '';
	}

	public upgradeButtonClicked() {
		this.showUpgradeModal = true;
	}

	public get deleteFlowErrorMessage() {
		if (this.parentFlows.length > 0) {
			return 'Cannot delete a flow that is transitioned to by another flow';
		}
		return '';
	}

	private hasLiveParentFlows() {
		return this.parentFlows.filter(parentFlow => parentFlow.status === FlowStatus.Live).length > 0;
	}

	private hasLiveParentAnswers() {
		return this.parentAnswers.filter(parentAnswer => parentAnswer.status === FlowStatus.Live).length > 0;
	}

	private async fetchFlow() {
		await this.loadFlow(this.flowId);
		this.flowLoaded = true;
	}

	private resetTracking() {
		this.resetChangeTracker();
		this.unsubscribeMutations = this.$store.subscribe(this.trackChanges);
	}

	private trackChanges(mutation: MutationPayload, state: any) {
		const changeType = this.determineChangeType(mutation.type);
		if (changeType) {
			this.makeDirty(changeType);
		}
	}

	private determineChangeType(type: string): ChangeType | null {
		switch (type) {
			case ADD_PATH:
			case REMOVE_PATH:
			case UPDATE_PATH:
			case ADD_STATE:
			case REMOVE_STATE:
			case UPDATE_STATE:
				return ChangeType.Paths;

			case SET_FLOW_NAME:
				return ChangeType.Name;

			case SET_TRIGGER:
				return ChangeType.Triggers;

			case UPDATE_SCHEDULE_CONDITION:
			case UPDATE_TRIGGER_CONDITIONS:
			case UPDATE_AUDIENCE_CONDITIONS:
			case UPDATE_TARGET_CONTACT_TYPES:
				return ChangeType.Conditions;

			default:
				return null;
		}
	}

	private showModal(to: Route, from: Route, next: any) {
		if (this.hasMadeChanges && !to.params.confirmed) {
			this.setupLeaveModal(next);
		} else {
			next();
		}
	}

	private setupLeaveModal(next: any) {
		this.showLeaveModal = true;

		// we can continue or cancel the navigation if we hook into
		// the events emitted by the leave modal
		this.$nextTick(() => {
			this.$refs.leaveModal.$once('confirm', async () => {
				this.showLeaveModal = false;
				next();
			});
			this.$refs.leaveModal.$once('cancel', () => {
				this.showLeaveModal = false;
				next(false);
			});
		});
	}

	private pauseFlowErrorMessage() {
		if (this.hasLiveParentFlows() || this.hasLiveParentAnswers()) {
			return 'Cannot pause a flow that is transitioned to by a live flow or FAQ';
		}
		if (this.hasMadeChanges) {
			return 'Cannot pause a flow with unsaved changes';
		}
		return '';
	}
}
